import React from 'react';

import MentionUser from './mention-user';
import DiscussionName from './discussion-name';
import ProjectName from './project-name';
import TaskGroupName from './task-group-name';
import TaskName from './task-name';
import MilestoneName from './milestone-name';
import LabelName from './label-name';
import SubteamName from './subteam-name';

export const getMentionComponent = (type, id, key) => {
    switch (type) {
        case 'user':
            return <MentionUser key={key} id={id} />

        case 'discussion':
            return <strong key={key}><DiscussionName id={id} /></strong>

        case 'project':
            return <strong key={key}><ProjectName id={id} /></strong>

        case 'taskgroup':
            return <strong key={key}><TaskGroupName id={id} /></strong>

        case 'task':
            return <strong key={key}><TaskName id={id} /></strong>

        case 'milestone':
            return <strong key={key}><MilestoneName id={id} /></strong>

        case 'label':
            return <strong key={key}><LabelName id={id} /></strong>

        case 'subteam':
            return <strong key={key}><SubteamName id={id} /></strong>

        default:
            return null;
    }
}
